import { TypeformSnippet } from '..';
import styles from './PartnersTypeform.module.css';

export const PartnersTypeform = () => {
  return (
    <div className={styles.container}>
      <TypeformSnippet
        typeformId="mRmbCYc5"
        frameTitle="Book a call"
        className="typeform-container"
      />
    </div>
  );
};
